import { forNamespace } from 'app/common/lib/util/i18n';
import moment from 'moment';
const format = forNamespace();

/**
 * This should be moved over to the @trello/dates package, but it currently
 * depends on i18n functionality (which is in this @trello/app package). If/
 * when we move i18n to it's own package, move this function to the dates
 * package.
 */
export const getDateDeltaString = (
  date: Date,
  now: Date,
): 'just now' | string => {
  const dateObj = moment(date);
  const nowObj = moment(now);

  if (dateObj.isSame(nowObj, 'day')) {
    if (Math.abs(nowObj.diff(date, 'seconds')) < 10) {
      return format('just now');
    } else {
      return dateObj.from(now);
    }
  } else {
    return dateObj.calendar(now);
  }
};
